import { render, staticRenderFns } from "./HowItWorksNewNewCss.vue?vue&type=template&id=5808d78a&scoped=true"
import script from "./HowItWorksNewNewCss.vue?vue&type=script&setup=true&lang=js"
export * from "./HowItWorksNewNewCss.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HowItWorksNewNewCss.vue?vue&type=style&index=0&id=5808d78a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5808d78a",
  null
  
)

export default component.exports